<template>
  <v-row align="center" justify="center">
    <v-col cols="12" class="d-flex justify-center">
      <!-- Фильтр -->
      <v-card
        style="
          position: -webkit-sticky;
          position: sticky;
          top: 100px;
          width: 800px;
        "
        shaped
      >
        <v-card-title>
          <v-icon large left color="primary">mdi-filter</v-icon>
          <span class="title font-weight-light">Фильтр</span>
        </v-card-title>
        <v-form ref="form">
          <v-col class="d-flex">
            <v-text-field
              class="mx-2"
              v-model="dateStart"
              label="От"
              type="date"
              density="comfortable"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              mx-2
              v-model="dateEnd"
              label="До"
              type="date"
              density="comfortable"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex">
            <v-autocomplete
              label="Фильтр региона"
              item-text="name"
              item-value="id"
              :loading="loading.getDistributors"
              :items="cities"
              v-model="city"
              :rules="[rules.required]"
              persistent-hint
              hint="Выберите регион"
              return-object
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex">
            <v-autocomplete
              label="Фильтр для сравнения"
              item-text="name"
              item-value="id"
              :items="distributorFilials"
              v-model="selectedFilials"
              :rules="[rules.filials.required, rules.filials.limit]"
              :item-disabled="IsItemDisabled"
              persistent-hint
              hint="Выберите поставщика (поставщиков) для сравнения"
              return-object
              chips
              clearable
              deletable-chips
              multiple
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex">
            <v-btn
              :loading="loading.getExcelReport"
              @click="DownloadAveragePricesPreort()"
              block
              color="primary"
            >
              Скачать отчет
              <template v-slot:loader>
                <span>Подождите немного...</span>
              </template>
            </v-btn>
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
const MAX_COMPARE_FILIALS = 8;

export default {
  data: () => ({
    city: null,
    distributors: [],
    distributorFilial: null,
    distributorFilials: [],
    filials: [],
    selectedFilials: [],
    analyzes: [],
    analyzesPerPage: [],
    dateStart: null,
    dateEnd: null,
    cities: [],
    fileName: "",
    loading: {
      getDistributors: true,
      getAnalyzes: false,
      getExcelReport: false,
    },

    rules: {
      required: (value) => !!value || "Поле обязательно для заполнения.",
      filials: {
        required: (value) =>
          !(value.length == 0) || "Поле обязательно для заполнения.",
        limit: (value) =>
          !(value && value.length > MAX_COMPARE_FILIALS) ||
          `Нельзя выбрать больше ${MAX_COMPARE_FILIALS} поставщиков`,
      },
    },
  }),
  async mounted() {
    //this.GetDistributors();
    //this.GetFilials();
    this.GetCities();
  },
  methods: {
    IsItemDisabled(item) {
      return (
        this.selectedFilials.length >= MAX_COMPARE_FILIALS &&
        !this.selectedFilials.some((f) => f.id === item.id)
      );
    },
    GetDistributors() {
      this.$store
        .dispatch("DISTRIBUTORS_BY_USER_COUNTRY")
        .then(() => {
          this.distributorFilials =
            this.$store.getters.DISTRIBUTORS_BY_USER_COUNTRY;
          this.loading.getDistributors = false;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    GetDistributorFilials() {
      if (this.distributor == null) {
        this.distributorFilial = null;
        this.distributorFilials = [];
      } else {
        this.distributorFilials = this.distributor?.filials;
      }
    },
    GetFilials(id) {
      this.$store
        .dispatch("FILIALS")
        .then(() => {
          this.distributorFilials = [...this.$store.getters.FILIALS];
          this.distributorFilials = this.distributorFilials.filter(
            (x) => x.cityId == id
          );
          window.console.log(this.distributorFilials);
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    GetCities() {
      this.$store
        .dispatch("USER_COUNTRY_CITIES")
        .then(() => {
          //copy array
          this.cities = [...this.$store.getters.USER_COUNTRY_CITIES];
          this.cities.unshift({ id: 0, name: "Казахстан" });
          this.loading.getDistributors = false;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    DownloadAveragePricesPreort() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const request = {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        cityId: this.city.id,
        Filials: this.selectedFilials.map(x => x.id)
      };
      this.loading.getExcelReport = true;
      this.$store
        .dispatch("DOWNLOAD_AVERAGE_PRICES_REPORT", request)
         .then(() => {
           this.loading.getExcelReport = false;
         })
         .catch((error) => {
          this.loading.getExcelReport = false;
           window.console.log(error);
        });
    }
  },
  watch: {
    city(newVal) {
      window.console.log("Список городов изменился:", newVal);
      this.selectedFilials = [];
      if (newVal.id == 0) {
        this.GetDistributors();
        return;
      }

      this.GetFilials(newVal.id);
    },
    selectedFilials(newVal) {
      if (newVal.length > MAX_COMPARE_FILIALS) {
        this.selectedFilials = newVal.slice(0, MAX_COMPARE_FILIALS);
      }
    },
  },
};
</script>